<template>
  <div class="wrapper-earnPoint">
    <!-- Alert Earn Point Result -->
    <a-alert
      v-if="result_alert.show"
      :type="result_alert.type"
      closable
      @close="afterCloseModal"
    >
      <div slot="description">
        <div class="alert-content">
          <img
            v-if="result_alert.type == 'success'"
            src="@/assets/images/earn_point_success.svg"
            alt="earn point success logo"
          />
          <img
            v-if="result_alert.type == 'error'"
            src="@/assets/images/earn_point_error.svg"
            alt="earn point fail logo"
          />
          <div>
            <div class="title">{{ result_alert.title }}</div>
            <div v-if="result_alert.type === 'success'" class="point">
              {{ result_alert.desc }}
            </div>
            <div v-else class="desc">{{ result_alert.desc }}</div>
          </div>
        </div>
      </div>
    </a-alert>
    <!-- <button @click="checkModal">checkModal</button>  -->
    <!-- Support PC Tablet -->
    <div v-if="windowWidth >= 600 && windowHeight >= 600" class="h-100">
      <div
        class="image__hearder"
        crm_at="image_hearder"
        :style="{ backgroundImage: 'url(' + storeinfo.image_header + ')' }"
      >
        <div class="box_content">
          <div class="wrapper__earnpoint__page">
            <div class="wrapper_hearder">
              <LayoutHome ref="layoutHome" />
            </div>
            <div class="wrapper_content">
              <div class="row">
                <div v-if="isImgEarnPoint" class="col-6">
                  <div class="box-img">
                    <img
                      class="img-earnpoint"
                      crm_at="img_earnpoint"
                      :src="imgEarnPoint"
                      alt=""
                    />
                  </div>
                </div>
                <div class="col-6">
                  <div class="box-entercode pt-2">
                    <div
                      class="title-code"
                      crm_at="lbl_enter_code_to_earn_point"
                    >
                      {{ lbl.earnpoint.enter_code_to_earn_point }}
                    </div>
                    <div class="enter-code-wrapper">
                      <a-input
                        v-model="code_1"
                        crm_at="code_1"
                        type="text"
                        size="large"
                        :class="'input' + checkCode_1"
                        :placeholder="lbl.earnpoint.enter_code"
                        @change="inputCode1"
                      >
                        <div slot="suffix">
                          <div
                            v-if="checkCode_1 == 0 && !isPH && isUseScanCode"
                            crm_at="camera_scan"
                            class="camera-wrapper"
                            @click="scanCode(1)"
                          >
                            <div class="line-before-camera"></div>
                            <img
                              class="img-code-scan"
                              src="@/assets/images/camera.svg"
                              alt=""
                            />
                            <label
                              class="code-scan-text"
                              crm_at="lbl_camera_scan"
                            >
                              {{ lbl.earnpoint.btn_scan }}
                            </label>
                          </div>
                          <span
                            v-else-if="checkCode_1 == 1"
                            crm_at="checkcode_1"
                          >
                            <img
                              class="img-code"
                              src="@/assets/images/earn_success.svg"
                              alt=""
                            />
                            <label
                              class="code-success"
                              crm_at="lbl_checkcode_1"
                            >
                              +{{ this.point_1 }} {{ lbl.earnpoint.points }}
                            </label>
                          </span>
                          <span
                            v-else-if="checkCode_1 == 2"
                            crm_at="checkcode_1"
                          >
                            <img
                              class="img-code"
                              src="@/assets/images/earn_error.svg"
                              alt=""
                            />
                            <label class="code-error" crm_at="lbl_checkcode_1">
                              {{ lbl.earnpoint.used_code }}
                            </label>
                          </span>
                          <span
                            v-else-if="checkCode_1 == 3"
                            crm_at="checkcode_1"
                          >
                            <img
                              class="img-code"
                              src="@/assets/images/earn_error.svg"
                              alt=""
                            />
                            <label class="code-error" crm_at="lbl_checkcode_1">
                              {{ lbl.earnpoint.duplicate_code }}
                            </label>
                          </span>
                          <span
                            v-else-if="checkCode_1 == 4"
                            crm_at="checkcode_1"
                          >
                            <img
                              class="img-code"
                              src="@/assets/images/earn_error.svg"
                              alt=""
                            />
                            <label class="code-error" crm_at="lbl_checkcode_1">
                              {{ lbl.earnpoint.incorrect_code }}
                            </label>
                          </span>
                          <span
                            v-else-if="checkCode_1 == 5"
                            crm_at="checkcode_1"
                          >
                            <img
                              class="img-code"
                              src="@/assets/images/earn_error.svg"
                              alt=""
                            />
                            <label class="code-error" crm_at="lbl_checkcode_1">
                              {{ lbl.earnpoint.blocked_code }}
                            </label>
                          </span>
                        </div>
                      </a-input>
                      <a-input
                        v-model="code_2"
                        crm_at="code_2"
                        type="text"
                        size="large"
                        :class="'input' + checkCode_2"
                        :placeholder="lbl.earnpoint.enter_code"
                        @change="inputCode2"
                      >
                        <div slot="suffix">
                          <div
                            v-if="checkCode_2 == 0 && !isPH && isUseScanCode"
                            crm_at="camera_scan"
                            class="camera-wrapper"
                            @click="scanCode(2)"
                          >
                            <div class="line-before-camera"></div>
                            <img
                              class="img-code-scan"
                              src="@/assets/images/camera.svg"
                              alt=""
                            />
                            <label
                              class="code-scan-text"
                              crm_at="lbl_camera_scan"
                            >
                              {{ lbl.earnpoint.btn_scan }}
                            </label>
                          </div>
                          <span
                            v-else-if="checkCode_2 == 1"
                            crm_at="checkcode_2"
                          >
                            <img
                              class="img-code"
                              src="@/assets/images/earn_success.svg"
                              alt=""
                            />
                            <label
                              class="code-success"
                              crm_at="lbl_checkcode_2"
                            >
                              +{{ this.point_2 }} {{ lbl.earnpoint.points }}
                            </label>
                          </span>
                          <span
                            v-else-if="checkCode_2 == 2"
                            crm_at="checkcode_2"
                          >
                            <img
                              class="img-code"
                              src="@/assets/images/earn_error.svg"
                              alt=""
                            />
                            <label class="code-error" crm_at="lbl_checkcode_2">
                              {{ lbl.earnpoint.used_code }}
                            </label>
                          </span>
                          <span
                            v-else-if="checkCode_2 == 3"
                            crm_at="checkcode_2"
                          >
                            <img
                              class="img-code"
                              src="@/assets/images/earn_error.svg"
                              alt=""
                            />
                            <label class="code-error" crm_at="lbl_checkcode_2">
                              {{ lbl.earnpoint.duplicate_code }}
                            </label>
                          </span>
                          <span
                            v-else-if="checkCode_2 == 4"
                            crm_at="checkcode_2"
                          >
                            <img
                              class="img-code"
                              src="@/assets/images/earn_error.svg"
                              alt=""
                            />
                            <label class="code-error" crm_at="lbl_checkcode_2">
                              {{ lbl.earnpoint.incorrect_code }}
                            </label>
                          </span>
                          <span
                            v-else-if="checkCode_2 == 5"
                            crm_at="checkcode_2"
                          >
                            <img
                              class="img-code"
                              src="@/assets/images/earn_error.svg"
                              alt=""
                            />
                            <label class="code-error" crm_at="lbl_checkcode_2">
                              {{ lbl.earnpoint.blocked_code }}
                            </label>
                          </span>
                        </div>
                      </a-input>
                      <a-input
                        v-model="code_3"
                        crm_at="code_3"
                        type="text"
                        size="large"
                        :class="'input' + checkCode_3"
                        :placeholder="lbl.earnpoint.enter_code"
                        @change="inputCode3"
                      >
                        <div slot="suffix">
                          <div
                            v-if="checkCode_3 == 0 && !isPH && isUseScanCode"
                            crm_at="camera_scan"
                            class="camera-wrapper"
                            @click="scanCode(3)"
                          >
                            <div class="line-before-camera"></div>
                            <img
                              class="img-code-scan"
                              src="@/assets/images/camera.svg"
                              alt=""
                            />
                            <label
                              class="code-scan-text"
                              crm_at="lbl_camera_scan"
                            >
                              {{ lbl.earnpoint.btn_scan }}
                            </label>
                          </div>
                          <span
                            v-else-if="checkCode_3 == 1"
                            crm_at="checkcode_3"
                          >
                            <img
                              class="img-code"
                              src="@/assets/images/earn_success.svg"
                              alt=""
                            />
                            <label
                              class="code-success"
                              crm_at="lbl_checkcode_3"
                            >
                              +{{ this.point_3 }} {{ lbl.earnpoint.points }}
                            </label>
                          </span>
                          <span
                            v-else-if="checkCode_3 == 2"
                            crm_at="checkcode_3"
                          >
                            <img
                              class="img-code"
                              src="@/assets/images/earn_error.svg"
                              alt=""
                            />
                            <label class="code-error" crm_at="lbl_checkcode_3">
                              {{ lbl.earnpoint.used_code }}
                            </label>
                          </span>
                          <span
                            v-else-if="checkCode_3 == 3"
                            crm_at="checkcode_3"
                          >
                            <img
                              class="img-code"
                              src="@/assets/images/earn_error.svg"
                              alt=""
                            />
                            <label class="code-error" crm_at="lbl_checkcode_3">
                              {{ lbl.earnpoint.duplicate_code }}
                            </label>
                          </span>
                          <span
                            v-else-if="checkCode_3 == 4"
                            crm_at="checkcode_3"
                          >
                            <img
                              class="img-code"
                              src="@/assets/images/earn_error.svg"
                              alt=""
                            />
                            <label class="code-error" crm_at="lbl_checkcode_3">
                              {{ lbl.earnpoint.incorrect_code }}
                            </label>
                          </span>
                          <span
                            v-else-if="checkCode_3 == 5"
                            crm_at="checkcode_3"
                          >
                            <img
                              class="img-code"
                              src="@/assets/images/earn_error.svg"
                              alt=""
                            />
                            <label class="code-error" crm_at="lbl_checkcode_3">
                              {{ lbl.earnpoint.blocked_code }}
                            </label>
                          </span>
                        </div>
                      </a-input>
                      <a-input
                        v-model="code_4"
                        crm_at="code_4"
                        type="text"
                        size="large"
                        :class="'input' + checkCode_4"
                        :placeholder="lbl.earnpoint.enter_code"
                        @change="inputCode4"
                      >
                        <div slot="suffix">
                          <div
                            v-if="checkCode_4 == 0 && !isPH && isUseScanCode"
                            crm_at="camera_scan"
                            class="camera-wrapper"
                            @click="scanCode(4)"
                          >
                            <div class="line-before-camera"></div>
                            <img
                              class="img-code-scan"
                              src="@/assets/images/camera.svg"
                              alt=""
                            />
                            <label
                              class="code-scan-text"
                              crm_at="lbl_camera_scan"
                            >
                              {{ lbl.earnpoint.btn_scan }}
                            </label>
                          </div>
                          <span
                            v-else-if="checkCode_4 == 1"
                            crm_at="checkcode_4"
                          >
                            <img
                              class="img-code"
                              src="@/assets/images/earn_success.svg"
                              alt=""
                            />
                            <label
                              class="code-success"
                              crm_at="lbl_checkcode_4"
                            >
                              +{{ this.point_4 }} {{ lbl.earnpoint.points }}
                            </label>
                          </span>
                          <span
                            v-else-if="checkCode_4 == 2"
                            crm_at="checkcode_4"
                          >
                            <img
                              class="img-code"
                              src="@/assets/images/earn_error.svg"
                              alt=""
                            />
                            <label class="code-error" crm_at="lbl_checkcode_4">
                              {{ lbl.earnpoint.used_code }}
                            </label>
                          </span>
                          <span
                            v-else-if="checkCode_4 == 3"
                            crm_at="checkcode_4"
                          >
                            <img
                              class="img-code"
                              src="@/assets/images/earn_error.svg"
                              alt=""
                            />
                            <label class="code-error" crm_at="lbl_checkcode_4">
                              {{ lbl.earnpoint.duplicate_code }}
                            </label>
                          </span>
                          <span
                            v-else-if="checkCode_4 == 4"
                            crm_at="checkcode_4"
                          >
                            <img
                              class="img-code"
                              src="@/assets/images/earn_error.svg"
                              alt=""
                            />
                            <label class="code-error" crm_at="lbl_checkcode_4">
                              {{ lbl.earnpoint.incorrect_code }}
                            </label>
                          </span>
                          <span
                            v-else-if="checkCode_4 == 5"
                            crm_at="checkcode_4"
                          >
                            <img
                              class="img-code"
                              src="@/assets/images/earn_error.svg"
                              alt=""
                            />
                            <label class="code-error" crm_at="lbl_checkcode_4">
                              {{ lbl.earnpoint.blocked_code }}
                            </label>
                          </span>
                        </div>
                      </a-input>
                      <a-input
                        v-model="code_5"
                        crm_at="code_5"
                        type="text"
                        size="large"
                        :class="'input' + checkCode_5"
                        :placeholder="lbl.earnpoint.enter_code"
                        @change="inputCode5"
                      >
                        <div slot="suffix">
                          <div
                            v-if="checkCode_5 == 0 && !isPH && isUseScanCode"
                            crm_at="camera_scan"
                            class="camera-wrapper"
                            @click="scanCode(5)"
                          >
                            <div class="line-before-camera"></div>
                            <img
                              class="img-code-scan"
                              src="@/assets/images/camera.svg"
                              alt=""
                            />
                            <label
                              class="code-scan-text"
                              crm_at="lbl_camera_scan"
                            >
                              {{ lbl.earnpoint.btn_scan }}
                            </label>
                          </div>
                          <span
                            v-else-if="checkCode_5 == 1"
                            crm_at="checkcode_5"
                          >
                            <img
                              class="img-code"
                              src="@/assets/images/earn_success.svg"
                              alt=""
                            />
                            <label
                              class="code-success"
                              crm_at="lbl_checkcode_5"
                            >
                              +{{ this.point_5 }} {{ lbl.earnpoint.points }}
                            </label>
                          </span>
                          <span
                            v-else-if="checkCode_5 == 2"
                            crm_at="checkcode_5"
                          >
                            <img
                              class="img-code"
                              src="@/assets/images/earn_error.svg"
                              alt=""
                            />
                            <label class="code-error" crm_at="lbl_checkcode_5">
                              {{ lbl.earnpoint.used_code }}
                            </label>
                          </span>
                          <span
                            v-else-if="checkCode_5 == 3"
                            crm_at="checkcode_5"
                          >
                            <img
                              class="img-code"
                              src="@/assets/images/earn_error.svg"
                              alt=""
                            />
                            <label class="code-error" crm_at="lbl_checkcode_5">
                              {{ lbl.earnpoint.duplicate_code }}
                            </label>
                          </span>
                          <span
                            v-else-if="checkCode_5 == 4"
                            crm_at="checkcode_5"
                          >
                            <img
                              class="img-code"
                              src="@/assets/images/earn_error.svg"
                              alt=""
                            />
                            <label class="code-error" crm_at="lbl_checkcode_5">
                              {{ lbl.earnpoint.incorrect_code }}
                            </label>
                          </span>
                          <span
                            v-else-if="checkCode_5 == 5"
                            crm_at="checkcode_5"
                          >
                            <img
                              class="img-code"
                              src="@/assets/images/earn_error.svg"
                              alt=""
                            />
                            <label class="code-error" crm_at="lbl_checkcode_5">
                              {{ lbl.earnpoint.blocked_code }}
                            </label>
                          </span>
                        </div>
                      </a-input>
                    </div>
                  </div>
                  <!-- eslint-disable vue/no-v-html -->
                  <div class="earnpoint-explanation" v-html="explanation" />
                </div>
              </div>
              <footer class="footer">
                <div class="row">
                  <div class="col-12">
                    <div class="container">
                      <a
                        class="menu menu-resize"
                        crm_at="btn_submit"
                        :style="{
                          'background-color': backgroundColor
                            ? backgroundColor
                            : '#1890ff',
                          'border-color': backgroundColor
                            ? backgroundColor
                            : '#1890ff',
                        }"
                        @click="handleSubmit"
                      >
                        <label
                          class="btn-submit"
                          :style="{ color: textColor ? textColor : '#FFF' }"
                          crm_at="btn_submit"
                        >
                          {{ lbl.btn.submit_two }}
                        </label>
                      </a>
                    </div>
                  </div>
                </div>
              </footer>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Support Mobile -->
    <div v-else>
      <div class="row wrapper-detail">
        <div class="col-12">
          <div class="box-profile">
            <a href="/missionhub" class="image-back" crm_at="btn_back_home">
              <img src="@/assets/images/Btn_Back.svg" alt="" />
            </a>
            <div class="profile">
              <div crm_at="lbl_point">
                {{ lbl.earnpoint.you_have }}
                <br />
                <span class="lbl-point-w">{{ this.textPoint }}</span>
                {{ lbl.earnpoint.points }}
              </div>
              <img
                v-if="profile_url"
                class="profile_image"
                crm_at="profile_image"
                :src="profile_url"
                alt="Avatar"
              />
              <a-avatar
                v-else
                slot="avatar"
                crm_at="avatar_profile"
                :size="60"
                icon="user"
              />
            </div>
          </div>
          <div v-if="isImgEarnPoint" class="box-img">
            <img
              class="img-earnpoint"
              crm_at="img_earnpoint"
              :src="imgEarnPoint"
              alt=""
            />
          </div>
          <div class="box-entercode pt-2">
            <div class="title-code" crm_at="lbl_enter_code_to_earn_point">
              {{ lbl.earnpoint.enter_code_to_earn_point }}
            </div>
            <div class="enter-code-wrapper">
              <a-input
                v-model="code_1"
                crm_at="code_1"
                type="text"
                size="large"
                :class="'input' + checkCode_1"
                :placeholder="lbl.earnpoint.enter_code"
                @change="inputCode1"
              >
                <div slot="suffix">
                  <div
                    v-if="checkCode_1 == 0 && !isPH && isUseScanCode"
                    crm_at="camera_scan"
                    class="camera-wrapper"
                    @click="scanCode(1)"
                  >
                    <div class="line-before-camera"></div>
                    <img
                      class="img-code-scan"
                      src="@/assets/images/camera.svg"
                      alt=""
                    />
                    <label class="code-scan-text" crm_at="lbl_camera_scan">
                      {{ lbl.earnpoint.btn_scan }}
                    </label>
                  </div>
                  <span v-else-if="checkCode_1 == 1" crm_at="checkcode_1">
                    <img
                      class="img-code"
                      src="@/assets/images/earn_success.svg"
                      alt=""
                    />
                    <label class="code-success" crm_at="lbl_checkcode_1">
                      {{ this.point_1 }} {{ lbl.earnpoint.points }}
                    </label>
                  </span>
                  <span v-else-if="checkCode_1 == 2" crm_at="checkcode_1">
                    <img
                      class="img-code"
                      src="@/assets/images/earn_error.svg"
                      alt=""
                    />
                    <label class="code-error" crm_at="lbl_checkcode_1">
                      {{ lbl.earnpoint.used_code }}
                    </label>
                  </span>
                  <span v-else-if="checkCode_1 == 3" crm_at="checkcode_1">
                    <img
                      class="img-code"
                      src="@/assets/images/earn_error.svg"
                      alt=""
                    />
                    <label class="code-error" crm_at="lbl_checkcode_1">
                      {{ lbl.earnpoint.duplicate_code }}
                    </label>
                  </span>
                  <span v-else-if="checkCode_1 == 4" crm_at="checkcode_1">
                    <img
                      class="img-code"
                      src="@/assets/images/earn_error.svg"
                      alt=""
                    />
                    <label class="code-error" crm_at="lbl_checkcode_1">
                      {{ lbl.earnpoint.incorrect_code }}
                    </label>
                  </span>
                  <span v-else-if="checkCode_1 == 5" crm_at="checkcode_1">
                    <img
                      class="img-code"
                      src="@/assets/images/earn_error.svg"
                      alt=""
                    />
                    <label class="code-error" crm_at="lbl_checkcode_1">
                      {{ lbl.earnpoint.blocked_code }}
                    </label>
                  </span>
                </div>
              </a-input>
              <a-input
                v-model="code_2"
                crm_at="code_2"
                type="text"
                size="large"
                :class="'input' + checkCode_2"
                :placeholder="lbl.earnpoint.enter_code"
                @change="inputCode2"
              >
                <div slot="suffix">
                  <div
                    v-if="checkCode_2 == 0 && !isPH && isUseScanCode"
                    crm_at="camera_scan"
                    class="camera-wrapper"
                    @click="scanCode(2)"
                  >
                    <div class="line-before-camera"></div>
                    <img
                      class="img-code-scan"
                      src="@/assets/images/camera.svg"
                      alt=""
                    />
                    <label class="code-scan-text" crm_at="lbl_camera_scan">
                      {{ lbl.earnpoint.btn_scan }}
                    </label>
                  </div>
                  <span v-else-if="checkCode_2 == 1" crm_at="checkcode_2">
                    <img
                      class="img-code"
                      src="@/assets/images/earn_success.svg"
                      alt=""
                    />
                    <label class="code-success" crm_at="lbl_checkcode_2">
                      {{ this.point_2 }} {{ lbl.earnpoint.points }}
                    </label>
                  </span>
                  <span v-else-if="checkCode_2 == 2" crm_at="checkcode_2">
                    <img
                      class="img-code"
                      src="@/assets/images/earn_error.svg"
                      alt=""
                    />
                    <label class="code-error" crm_at="lbl_checkcode_2">
                      {{ lbl.earnpoint.used_code }}
                    </label>
                  </span>
                  <span v-else-if="checkCode_2 == 3" crm_at="checkcode_2">
                    <img
                      class="img-code"
                      src="@/assets/images/earn_error.svg"
                      alt=""
                    />
                    <label class="code-error" crm_at="lbl_checkcode_2">
                      {{ lbl.earnpoint.duplicate_code }}
                    </label>
                  </span>
                  <span v-else-if="checkCode_2 == 4" crm_at="checkcode_2">
                    <img
                      class="img-code"
                      src="@/assets/images/earn_error.svg"
                      alt=""
                    />
                    <label class="code-error" crm_at="lbl_checkcode_2">
                      {{ lbl.earnpoint.incorrect_code }}
                    </label>
                  </span>
                  <span v-else-if="checkCode_2 == 5" crm_at="checkcode_2">
                    <img
                      class="img-code"
                      src="@/assets/images/earn_error.svg"
                      alt=""
                    />
                    <label class="code-error" crm_at="lbl_checkcode_2">
                      {{ lbl.earnpoint.blocked_code }}
                    </label>
                  </span>
                </div>
              </a-input>
              <a-input
                v-model="code_3"
                crm_at="code_3"
                type="text"
                size="large"
                :class="'input' + checkCode_3"
                :placeholder="lbl.earnpoint.enter_code"
                @change="inputCode3"
              >
                <div slot="suffix">
                  <div
                    v-if="checkCode_3 == 0 && !isPH && isUseScanCode"
                    crm_at="camera_scan"
                    class="camera-wrapper"
                    @click="scanCode(3)"
                  >
                    <div class="line-before-camera"></div>
                    <img
                      class="img-code-scan"
                      src="@/assets/images/camera.svg"
                      alt=""
                    />
                    <label class="code-scan-text" crm_at="lbl_camera_scan">
                      {{ lbl.earnpoint.btn_scan }}
                    </label>
                  </div>
                  <span v-else-if="checkCode_3 == 1" crm_at="checkcode_3">
                    <img
                      class="img-code"
                      src="@/assets/images/earn_success.svg"
                      alt=""
                    />
                    <label class="code-success" crm_at="lbl_checkcode_3">
                      {{ this.point_3 }} {{ lbl.earnpoint.points }}
                    </label>
                  </span>
                  <span v-else-if="checkCode_3 == 2" crm_at="checkcode_3">
                    <img
                      class="img-code"
                      src="@/assets/images/earn_error.svg"
                      alt=""
                    />
                    <label class="code-error" crm_at="lbl_checkcode_3">
                      {{ lbl.earnpoint.used_code }}
                    </label>
                  </span>
                  <span v-else-if="checkCode_3 == 3" crm_at="checkcode_3">
                    <img
                      class="img-code"
                      src="@/assets/images/earn_error.svg"
                      alt=""
                    />
                    <label class="code-error" crm_at="lbl_checkcode_3">
                      {{ lbl.earnpoint.duplicate_code }}
                    </label>
                  </span>
                  <span v-else-if="checkCode_3 == 4" crm_at="checkcode_3">
                    <img
                      class="img-code"
                      src="@/assets/images/earn_error.svg"
                      alt=""
                    />
                    <label class="code-error" crm_at="lbl_checkcode_3">
                      {{ lbl.earnpoint.incorrect_code }}
                    </label>
                  </span>
                  <span v-else-if="checkCode_3 == 5" crm_at="checkcode_3">
                    <img
                      class="img-code"
                      src="@/assets/images/earn_error.svg"
                      alt=""
                    />
                    <label class="code-error" crm_at="lbl_checkcode_3">
                      {{ lbl.earnpoint.blocked_code }}
                    </label>
                  </span>
                </div>
              </a-input>
              <a-input
                v-model="code_4"
                crm_at="code_4"
                type="text"
                size="large"
                :class="'input' + checkCode_4"
                :placeholder="lbl.earnpoint.enter_code"
                @change="inputCode4"
              >
                <div slot="suffix">
                  <div
                    v-if="checkCode_4 == 0 && !isPH && isUseScanCode"
                    crm_at="camera_scan"
                    class="camera-wrapper"
                    @click="scanCode(4)"
                  >
                    <div class="line-before-camera"></div>
                    <img
                      class="img-code-scan"
                      src="@/assets/images/camera.svg"
                      alt=""
                    />
                    <label class="code-scan-text" crm_at="lbl_camera_scan">
                      {{ lbl.earnpoint.btn_scan }}
                    </label>
                  </div>
                  <span v-else-if="checkCode_4 == 1" crm_at="checkcode_4">
                    <img
                      class="img-code"
                      src="@/assets/images/earn_success.svg"
                      alt=""
                    />
                    <label class="code-success" crm_at="lbl_checkcode_4">
                      {{ this.point_4 }} {{ lbl.earnpoint.points }}
                    </label>
                  </span>
                  <span v-else-if="checkCode_4 == 2" crm_at="checkcode_4">
                    <img
                      class="img-code"
                      src="@/assets/images/earn_error.svg"
                      alt=""
                    />
                    <label class="code-error" crm_at="lbl_checkcode_4">
                      {{ lbl.earnpoint.used_code }}
                    </label>
                  </span>
                  <span v-else-if="checkCode_4 == 3" crm_at="checkcode_4">
                    <img
                      class="img-code"
                      src="@/assets/images/earn_error.svg"
                      alt=""
                    />
                    <label class="code-error" crm_at="lbl_checkcode_4">
                      {{ lbl.earnpoint.duplicate_code }}
                    </label>
                  </span>
                  <span v-else-if="checkCode_4 == 4" crm_at="checkcode_4">
                    <img
                      class="img-code"
                      src="@/assets/images/earn_error.svg"
                      alt=""
                    />
                    <label class="code-error" crm_at="lbl_checkcode_4">
                      {{ lbl.earnpoint.incorrect_code }}
                    </label>
                  </span>
                  <span v-else-if="checkCode_4 == 5" crm_at="checkcode_4">
                    <img
                      class="img-code"
                      src="@/assets/images/earn_error.svg"
                      alt=""
                    />
                    <label class="code-error" crm_at="lbl_checkcode_4">
                      {{ lbl.earnpoint.blocked_code }}
                    </label>
                  </span>
                </div>
              </a-input>
              <a-input
                v-model="code_5"
                crm_at="code_5"
                type="text"
                size="large"
                :class="'input' + checkCode_5"
                :placeholder="lbl.earnpoint.enter_code"
                @change="inputCode5"
              >
                <div slot="suffix">
                  <div
                    v-if="checkCode_5 == 0 && !isPH && isUseScanCode"
                    crm_at="camera_scan"
                    class="camera-wrapper"
                    @click="scanCode(5)"
                  >
                    <div class="line-before-camera"></div>
                    <img
                      class="img-code-scan"
                      src="@/assets/images/camera.svg"
                      alt=""
                    />
                    <label class="code-scan-text" crm_at="lbl_camera_scan">
                      {{ lbl.earnpoint.btn_scan }}
                    </label>
                  </div>
                  <span v-else-if="checkCode_5 == 1" crm_at="checkcode_5">
                    <img
                      class="img-code"
                      src="@/assets/images/earn_success.svg"
                      alt=""
                    />
                    <label class="code-success" crm_at="lbl_checkcode_5">
                      {{ this.point_5 }} {{ lbl.earnpoint.points }}
                    </label>
                  </span>
                  <span v-else-if="checkCode_5 == 2" crm_at="checkcode_5">
                    <img
                      class="img-code"
                      src="@/assets/images/earn_error.svg"
                      alt=""
                    />
                    <label class="code-error" crm_at="lbl_checkcode_5">
                      {{ lbl.earnpoint.used_code }}
                    </label>
                  </span>
                  <span v-else-if="checkCode_5 == 3" crm_at="checkcode_5">
                    <img
                      class="img-code"
                      src="@/assets/images/earn_error.svg"
                      alt=""
                    />
                    <label class="code-error" crm_at="lbl_checkcode_5">
                      {{ lbl.earnpoint.duplicate_code }}
                    </label>
                  </span>
                  <span v-else-if="checkCode_5 == 4" crm_at="checkcode_5">
                    <img
                      class="img-code"
                      src="@/assets/images/earn_error.svg"
                      alt=""
                    />
                    <label class="code-error" crm_at="lbl_checkcode_5">
                      {{ lbl.earnpoint.incorrect_code }}
                    </label>
                  </span>
                  <span v-else-if="checkCode_5 == 5" crm_at="checkcode_5">
                    <img
                      class="img-code"
                      src="@/assets/images/earn_error.svg"
                      alt=""
                    />
                    <label class="code-error" crm_at="lbl_checkcode_5">
                      {{ lbl.earnpoint.blocked_code }}
                    </label>
                  </span>
                </div>
              </a-input>
            </div>
          </div>
          <!-- eslint-disable vue/no-v-html -->
          <div class="earnpoint-explanation" v-html="explanation" />
        </div>
      </div>

      <footer class="footer earnpoint">
        <div class="row">
          <div class="col-12">
            <div class="container not-locale">
              <a
                class="menu menu-resize"
                crm_at="btn_submit"
                :style="{
                  'background-color': backgroundColor
                    ? backgroundColor
                    : '#1890ff',
                  'border-color': backgroundColor ? backgroundColor : '#1890ff',
                }"
                @click="handleSubmit"
              >
                <label
                  class="btn-submit"
                  :style="{ color: textColor ? textColor : '#FFF' }"
                  crm_at="btn_submit"
                >
                  {{ lbl.btn.submit_two }}
                </label>
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
    <AlertError
      :show="showError"
      :data="dataError"
      @changeError="ChangeError($event)"
    />

    <!-- <Notification :show="showNotification" :data="dataNotification" @changeNotification="ChangeNotification($event)" /> -->
    <CameraScanModal
      :show="isScanCode"
      :input-number="scanInputNumber"
      :store-style="storeStyle"
      @result="handleScanResult($event)"
      @error="handleScanError($event)"
      @close="isScanCode = false"
    />
  </div>
</template>

<script>
import Vue from 'vue'
import CommonMixin from '@/mixin/CommonMixin'
import ResponsiveMixin from '@/mixin/ResponsiveMixin'
import BzbsDashboard from '@/core/Home/BzbsDashboard'
import BzbsEarnPoint from '@/core/EarnPoint/service/BzbsEarnPoint'
import AlertError from '@/components/Modal/AlertError'
import Account from '@/helper/AccountHelper.js'
import LayoutHome from '@/module/components/Home/LayoutHome'
import CameraScanModal from '@/components/Modal/CameraScanModal.vue'
import liff from '@line/liff'

export default {
  name: 'EarnPoint',
  components: {
    AlertError,
    CameraScanModal,
    LayoutHome,
  },
  mixins: [CommonMixin, ResponsiveMixin],
  data() {
    return {
      backgroundColor: '',
      textColor: '',
      showError: false,
      dataError: {},
      imgEarnPoint: '',
      profile_url: '',
      textPoint: '0',
      code_1: '',
      code_2: '',
      code_3: '',
      code_4: '',
      code_5: '',
      checkCode_1: 0,
      checkCode_2: 0,
      checkCode_3: 0,
      checkCode_4: 0,
      checkCode_5: 0,
      point_1: '',
      point_2: '',
      point_3: '',
      point_4: '',
      point_5: '',
      explanation: '',
      storeinfo: {
        image_header: '',
        image_logo: '',
        businessName: '',
      },
      storeStyle: {
        'background-color': '#1890ff',
        'border-color': '#1890ff',
        color: '#FFF',
      },
      windowWidth: window.innerWidth,
      windowHeight: window.innerHeight,
      isImgEarnPoint: false,
      showNotification: false,
      dataNotification: {},
      isScanCode: false,
      scanInputNumber: null,
      modaltimeOut: null,
      result_alert: {
        type: null,
        title: null,
        desc: null,
      },
      isPH: false,
      isUseScanCode: false,
    }
  },
  destroyed() {
    window.removeEventListener('resize', this.myEventShowLanguage)
  },
  created() {
    Account.bzbsAnalyticTracking(
      'earnpoint_page',
      'earnpoint_page',
      'view_earnpoint_page',
      'on view',
    )
    this.isPH = Vue.bzbsConfig.businessRule.webFor.PH
    this.checklocalStorage().then(() => {
      this.handleCheckLogin(this.$route)
      this.handleCheckRegister()
      window.addEventListener('resize', this.myEventShowLanguage)
      this.init()
    })
    this.initLiff()
  },
  methods: {
    checkModal() {
      // this.result_alert.show = true
      // this.result_alert.type = 'success'
      // this.result_alert.title = this.lbl.earnpoint.earnpoint_success
      // this.result_alert.desc = 10 + ' ' + this.lbl.earnpoint.points
      this.result_alert.show = true
      this.result_alert.type = 'error'
      this.result_alert.title = this.lbl.earnpoint.earnpoint_error
      this.result_alert.desc = this.lbl.earnpoint.earnpoint_error_desc
      this.$forceUpdate()
      clearTimeout(this.modaltimeOut)
      this.modaltimeOut = setTimeout(() => {
        this.afterCloseModal()
      }, 5000)
    },
    async initLiff() {
      try {
        await liff.init({
          liffId: Account.getCacheCustomByAppId('liffId'),
        })
      } catch (error) {
        console.log('scanCodeV2', error.message)
      }
    },
    async scanCodeLineDe(inputNumber) {
      try {
        const result = await liff.scanCodeV2()
        this.scanInputNumber = inputNumber
        let scanresult = {
          text: result.value,
          number: inputNumber,
        }
        this.handleScanResult(scanresult)
      } catch (error) {
        this.showError = true
        this.dataError = {
          title: this.lbl.error.errortitle,
          detail: error.message + ' : ' + error.message,
        }
        console.log('scanCodeV2', error.message)
      }
    },
    gotoScanCode() {
      Account.gotoScan(false, 'missionhub')
    },
    afterCloseModal() {
      this.checkCode_1 = 0
      this.checkCode_2 = 0
      this.checkCode_3 = 0
      this.checkCode_4 = 0
      this.checkCode_5 = 0

      this.code_1 = ''
      this.code_2 = ''
      this.code_3 = ''
      this.code_4 = ''
      this.code_5 = ''
      if (this.windowWidth >= 600 && this.windowHeight >= 600) {
        this.$refs['layoutHome'].getProfile().then(() => {
          this.handleLoading(false)
        })
      } else {
        this.getProfile()
      }
      this.$forceUpdate()
      this.result_alert.show = false
    },
    scanCode(inputNumber) {
      console.log('click scan code !!!!!!!! at input ', inputNumber)
      this.isScanCode = !this.isScanCode
      this.scanInputNumber = inputNumber
    },
    handleScanResult(value) {
      this.scanInputNumber = null
      this.isScanCode = false
      switch (value.number) {
        case 1:
          this.code_1 = value.text
          break
        case 2:
          this.code_2 = value.text
          break
        case 3:
          this.code_3 = value.text
          break
        case 4:
          this.code_4 = value.text
          break
        case 5:
          this.code_5 = value.text
          break

        default:
          break
      }
    },
    handleScanError(value) {
      this.scanInputNumber = null
      this.isScanCode = false
      console.log(`scan error ${value}`)
      this.showError = true
      this.dataError = {
        title: this.lbl.error.errortitle,
        detail: value,
      }
    },
    init() {
      this.handleLoading(false)
      this.handleFooter(false)
      this.myEventShowLanguage()
      this.explanation = this.lbl.earnpoint.explanation
      this.getCustomerStore().then(res => {
        if (res.StoreDetail.IsEarnPointfromCode == undefined) {
          window.location.href = '/home'
        } else if (res.StoreDetail.IsEarnPointfromCode == false) {
          window.location.href = '/home'
        }
        this.getProfile()
        this.getblobearncode()
      })

      if (
        Account.getCacheCustom(
          'profileLine_' + Account.getCacheCustom('app_id'),
        )
      ) {
        if (
          Account.getCacheCustom(
            'profileLine_' + Account.getCacheCustom('app_id'),
          ).pictureUrl
        ) {
          this.profile_url = JSON.stringify(
            Account.getCacheCustom(
              'profileLine_' + Account.getCacheCustom('app_id'),
            ).pictureUrl,
          ).replace(/"/g, '')
        } else {
          this.profile_url = null
        }
      }
    },
    myEventShowLanguage() {
      setTimeout(() => this.checkLanguage(), 300)
    },
    checkLanguage() {
      if (this.windowWidth >= 600 && this.windowHeight >= 600) {
        this.handleLanguage(true)
      } else {
        this.handleLanguage(false)
      }
    },
    getCustomerStore() {
      this.handleLoading(true)

      return new Promise(resolve => {
        BzbsDashboard.getCustomerStore()
          .then(res => {
            this.handleLoading(false)
            this.genCustomerStore(res.data)
            resolve(res.data)
          })
          .catch(error => {
            this.handleLoading(false)
            this.showError = true
            this.dataError = {
              title: this.lbl.error.errortitle,
              detail: error.response.data.error.message,
            }
            console.log('getCustomerStore error', error)
            resolve(error)
          })
      })
    },
    genCustomerStore(data) {
      this.backgroundColor = data.StoreDetail.ButtonColor
      this.textColor = data.StoreDetail.ButtonTextColor
      this.isUseScanCode = data.Blob.IsShowScanCode
      this.storeStyle['background-color'] = data.StoreDetail.ButtonColor
      this.storeStyle['border-color'] = data.StoreDetail.ButtonColor
      this.storeStyle['color'] = data.StoreDetail.ButtonTextColor

      this.storeinfo.image_header = data.StoreDetail.CoverUrl
      this.storeinfo.image_logo = data.StoreDetail.LogoUrl
      this.storeinfo.businessName = data.StoreDetail.BusinessName
    },
    getProfile() {
      this.handleLoading(true)

      return new Promise(resolve => {
        BzbsDashboard.getProfile()
          .then(res => {
            this.handleLoading(false)
            this.textPoint = res.data.updated_points.points
            resolve(res.data)
          })
          .catch(error => {
            this.handleLoading(false)
            this.showError = true
            this.dataError = {
              title: this.lbl.error.errortitle,
              detail: error.response.data.error.message,
            }
            console.log('getProfile error', error)
            resolve(error)
          })
      })
    },
    getblobearncode() {
      this.handleLoading(true)
      return new Promise(resolve => {
        BzbsDashboard.getblobearncode()
          .then(res => {
            this.handleLoading(false)
            this.isImgEarnPoint = true
            if (res.data.data.ShowCampaignEnterCodeBannerUrl != null) {
              this.imgEarnPoint =
                res.data.data.ShowCampaignEnterCodeBannerUrl +
                `?v=` +
                new Date().getTime()
            } else {
              if (this.local == 'th') {
                this.imgEarnPoint = res.data.data.EnterCode.th
              } else {
                this.imgEarnPoint = res.data.data.EnterCode.en
              }
            }
            resolve(res.data)
          })
          .catch(error => {
            this.handleLoading(false)
            this.isImgEarnPoint = false
            resolve(error)
          })
      })
    },
    inputCode1() {
      this.checkCode_1 = 0
    },
    inputCode2() {
      this.checkCode_2 = 0
    },
    inputCode3() {
      this.checkCode_3 = 0
    },
    inputCode4() {
      this.checkCode_4 = 0
    },
    inputCode5() {
      this.checkCode_5 = 0
    },
    handleSubmit() {
      console.log('handleSubmit')
      this.checkCode_1 = 0
      this.checkCode_2 = 0
      this.checkCode_3 = 0
      this.checkCode_4 = 0
      this.checkCode_5 = 0

      let codes = []
      if (this.code_1 != '' && this.code_1 != null) {
        codes.push(this.code_1)
      }
      if (this.code_2 != '' && this.code_2 != null) {
        codes.push(this.code_2)
      }
      if (this.code_3 != '' && this.code_3 != null) {
        codes.push(this.code_3)
      }
      if (this.code_4 != '' && this.code_4 != null) {
        codes.push(this.code_4)
      }
      if (this.code_5 != '' && this.code_5 != null) {
        codes.push(this.code_5)
      }

      if (codes.length > 0) {
        this.postCouponProcess(codes)
      }
    },
    postEarnCode(codes) {
      return new Promise(resolve => {
        BzbsEarnPoint.postEarnCode(codes)
          .then(res => {
            this.handleLoading(false)
            if (res.data.success == true) {
              if (res.data.data.codes) {
                if (this.code_1 != '' && this.code_1 != null) {
                  if (res.data.data.codes[this.code_1].status == 'Success') {
                    this.checkCode_1 = 1
                    this.point_1 = res.data.data.codes[this.code_1].points
                  } else if (
                    res.data.data.codes[this.code_1].error ==
                    'code has already used'
                  ) {
                    this.checkCode_1 = 2
                  } else if (
                    res.data.data.codes[this.code_1].error ==
                    'code is duplicate'
                  ) {
                    this.checkCode_1 = 3
                  } else {
                    this.checkCode_1 = 4
                  }
                }
                if (this.code_2 != '' && this.code_2 != null) {
                  if (res.data.data.codes[this.code_2].status == 'Success') {
                    this.checkCode_2 = 1
                    this.point_2 = res.data.data.codes[this.code_2].points
                  } else if (
                    res.data.data.codes[this.code_2].error ==
                    'code has already used'
                  ) {
                    this.checkCode_2 = 2
                  } else if (
                    res.data.data.codes[this.code_2].error ==
                    'code is duplicate'
                  ) {
                    this.checkCode_2 = 3
                  } else {
                    this.checkCode_2 = 4
                  }
                }
                if (this.code_3 != '' && this.code_3 != null) {
                  if (res.data.data.codes[this.code_3].status == 'Success') {
                    this.checkCode_3 = 1
                    this.point_3 = res.data.data.codes[this.code_3].points
                  } else if (
                    res.data.data.codes[this.code_3].error ==
                    'code has already used'
                  ) {
                    this.checkCode_3 = 2
                  } else if (
                    res.data.data.codes[this.code_3].error ==
                    'code is duplicate'
                  ) {
                    this.checkCode_3 = 3
                  } else {
                    this.checkCode_3 = 4
                  }
                }
                if (this.code_4 != '' && this.code_4 != null) {
                  if (res.data.data.codes[this.code_4].status == 'Success') {
                    this.checkCode_4 = 1
                    this.point_4 = res.data.data.codes[this.code_4].points
                  } else if (
                    res.data.data.codes[this.code_4].error ==
                    'code has already used'
                  ) {
                    this.checkCode_4 = 2
                  } else if (
                    res.data.data.codes[this.code_4].error ==
                    'code is duplicate'
                  ) {
                    this.checkCode_4 = 3
                  } else {
                    this.checkCode_4 = 4
                  }
                }
                if (this.code_5 != '' && this.code_5 != null) {
                  if (res.data.data.codes[this.code_5].status == 'Success') {
                    this.checkCode_5 = 1
                    this.point_5 = res.data.data.codes[this.code_5].points
                  } else if (
                    res.data.data.codes[this.code_5].error ==
                    'code has already used'
                  ) {
                    this.checkCode_5 = 2
                  } else if (
                    res.data.data.codes[this.code_5].error ==
                    'code is duplicate'
                  ) {
                    this.checkCode_5 = 3
                  } else {
                    this.checkCode_5 = 4
                  }
                }

                if (res.data.data.success_count > 0) {
                  var point = 0
                  if (this.code_1 != '' && this.code_1 != null) {
                    if (res.data.data.codes[this.code_1].status == 'Success') {
                      point += res.data.data.codes[this.code_1].points
                    }
                  }
                  if (this.code_2 != '' && this.code_2 != null) {
                    if (res.data.data.codes[this.code_2].status == 'Success') {
                      point += res.data.data.codes[this.code_2].points
                    }
                  }
                  if (this.code_3 != '' && this.code_3 != null) {
                    if (res.data.data.codes[this.code_3].status == 'Success') {
                      point += res.data.data.codes[this.code_3].points
                    }
                  }
                  if (this.code_4 != '' && this.code_4 != null) {
                    if (res.data.data.codes[this.code_4].status == 'Success') {
                      point += res.data.data.codes[this.code_4].points
                    }
                  }
                  if (this.code_5 != '' && this.code_5 != null) {
                    if (res.data.data.codes[this.code_5].status == 'Success') {
                      point += res.data.data.codes[this.code_5].points
                    }
                  }

                  this.showNotification = true
                  this.dataNotification = {
                    condition: 'correct',
                    title: this.lbl.earnpoint.you_success,
                    detail: point,
                  }
                } else {
                  if (this.code_1 != '' && this.code_1 != null) {
                    if (
                      res.data.data.codes[this.code_1].error ==
                      'code has already used'
                    ) {
                      this.showNotification = true
                      this.dataNotification = {
                        condition: 'usecode',
                        title: this.lbl.earnpoint.used_code,
                      }
                    } else if (
                      res.data.data.codes[this.code_1].error ==
                      'code is duplicate'
                    ) {
                      this.showNotification = true
                      this.dataNotification = {
                        condition: 'duplicate',
                        title: this.lbl.earnpoint.duplicate_code,
                      }
                    } else {
                      this.showNotification = true
                      this.dataNotification = {
                        condition: 'incorrect',
                        title: this.lbl.earnpoint.incorrect_code,
                      }
                    }
                  } else if (this.code_2 != '' && this.code_2 != null) {
                    if (
                      res.data.data.codes[this.code_2].error ==
                      'code has already used'
                    ) {
                      this.showNotification = true
                      this.dataNotification = {
                        condition: 'usecode',
                        title: this.lbl.earnpoint.used_code,
                      }
                    } else if (
                      res.data.data.codes[this.code_2].error ==
                      'code is duplicate'
                    ) {
                      this.showNotification = true
                      this.dataNotification = {
                        condition: 'duplicate',
                        title: this.lbl.earnpoint.duplicate_code,
                      }
                    } else {
                      this.showNotification = true
                      this.dataNotification = {
                        condition: 'incorrect',
                        title: this.lbl.earnpoint.incorrect_code,
                      }
                    }
                  } else if (this.code_3 != '' && this.code_3 != null) {
                    if (
                      res.data.data.codes[this.code_3].error ==
                      'code has already used'
                    ) {
                      this.showNotification = true
                      this.dataNotification = {
                        condition: 'usecode',
                        title: this.lbl.earnpoint.used_code,
                      }
                    } else if (
                      res.data.data.codes[this.code_3].error ==
                      'code is duplicate'
                    ) {
                      this.showNotification = true
                      this.dataNotification = {
                        condition: 'duplicate',
                        title: this.lbl.earnpoint.duplicate_code,
                      }
                    } else {
                      this.showNotification = true
                      this.dataNotification = {
                        condition: 'incorrect',
                        title: this.lbl.earnpoint.incorrect_code,
                      }
                    }
                  } else if (this.code_4 != '' && this.code_4 != null) {
                    if (
                      res.data.data.codes[this.code_4].error ==
                      'code has already used'
                    ) {
                      this.showNotification = true
                      this.dataNotification = {
                        condition: 'usecode',
                        title: this.lbl.earnpoint.used_code,
                      }
                    } else if (
                      res.data.data.codes[this.code_4].error ==
                      'code is duplicate'
                    ) {
                      this.showNotification = true
                      this.dataNotification = {
                        condition: 'duplicate',
                        title: this.lbl.earnpoint.duplicate_code,
                      }
                    } else {
                      this.showNotification = true
                      this.dataNotification = {
                        condition: 'incorrect',
                        title: this.lbl.earnpoint.incorrect_code,
                      }
                    }
                  } else if (this.code_5 != '' && this.code_5 != null) {
                    if (
                      res.data.data.codes[this.code_5].error ==
                      'code has already used'
                    ) {
                      this.showNotification = true
                      this.dataNotification = {
                        condition: 'usecode',
                        title: this.lbl.earnpoint.used_code,
                      }
                    } else if (
                      res.data.data.codes[this.code_5].error ==
                      'code is duplicate'
                    ) {
                      this.showNotification = true
                      this.dataNotification = {
                        condition: 'duplicate',
                        title: this.lbl.earnpoint.duplicate_code,
                      }
                    } else {
                      this.showNotification = true
                      this.dataNotification = {
                        condition: 'incorrect',
                        title: this.lbl.earnpoint.incorrect_code,
                      }
                    }
                  }
                }
              } else {
                this.checkCode_1 = 4
                this.checkCode_2 = 4
                this.checkCode_3 = 4
                this.checkCode_4 = 4
                this.checkCode_5 = 4
              }
            } else {
              this.checkCode_1 = 5
              this.checkCode_2 = 5
              this.checkCode_3 = 5
              this.checkCode_4 = 5
              this.checkCode_5 = 5
            }
            resolve(res.data)
          })
          .catch(error => {
            this.handleLoading(false)
            if (error.response.data.error.code == 409) {
              if (this.code_1 != '' && this.code_1 != null) {
                if (
                  this.code_1 ==
                  error.response.data.error.message.substring(19, 27)
                ) {
                  this.checkCode_1 = 3
                }
              }
              if (this.code_2 != '' && this.code_2 != null) {
                if (
                  this.code_2 ==
                  error.response.data.error.message.substring(19, 27)
                ) {
                  this.checkCode_2 = 3
                }
              }
              if (this.code_3 != '' && this.code_3 != null) {
                if (
                  this.code_3 ==
                  error.response.data.error.message.substring(19, 27)
                ) {
                  this.checkCode_3 = 3
                }
              }
              if (this.code_4 != '' && this.code_4 != null) {
                if (
                  this.code_4 ==
                  error.response.data.error.message.substring(19, 27)
                ) {
                  this.checkCode_4 = 3
                }
              }
              if (this.code_5 != '' && this.code_5 != null) {
                if (
                  this.code_5 ==
                  error.response.data.error.message.substring(19, 27)
                ) {
                  this.checkCode_5 = 3
                }
              }
            } else if (error.response.data.error.code == 403) {
              this.showError = true
              this.dataError = {
                title: this.lbl.error.errortitle,
                detail: this.lbl.error.you_can_not_enter_code,
              }
            } else {
              this.showError = true
              this.dataError = {
                title: this.lbl.error.errortitle,
                detail: error.response.data.error.message,
              }
            }
            console.log('postEarnCode error', error)
            resolve(error)
          })
      })
    },
    postCouponProcess(codes) {
      this.handleLoading(true)

      return new Promise(resolve => {
        BzbsEarnPoint.postCouponProcess(codes)
          .then(res => {
            if (res.data.success == true) {
              if (res.data.data.codes) {
                if (this.code_1 != '' && this.code_1 != null) {
                  if (res.data.data.codes[this.code_1].status == 'Success') {
                    this.checkCode_1 = 1
                    this.point_1 = res.data.data.codes[this.code_1].points_earn
                  } else if (
                    res.data.data.codes[this.code_1].status == 'Used'
                  ) {
                    this.checkCode_1 = 2
                  } else {
                    this.checkCode_1 = 4
                  }
                }
                if (this.code_2 != '' && this.code_2 != null) {
                  if (res.data.data.codes[this.code_2].status == 'Success') {
                    this.checkCode_2 = 1
                    this.point_2 = res.data.data.codes[this.code_2].points_earn
                  } else if (
                    res.data.data.codes[this.code_2].status == 'Used'
                  ) {
                    this.checkCode_2 = 2
                  } else {
                    this.checkCode_2 = 4
                  }
                }
                if (this.code_3 != '' && this.code_3 != null) {
                  if (res.data.data.codes[this.code_3].status == 'Success') {
                    this.checkCode_3 = 1
                    this.point_3 = res.data.data.codes[this.code_3].points_earn
                  } else if (
                    res.data.data.codes[this.code_3].status == 'Used'
                  ) {
                    this.checkCode_3 = 2
                  } else {
                    this.checkCode_3 = 4
                  }
                }
                if (this.code_4 != '' && this.code_4 != null) {
                  if (res.data.data.codes[this.code_4].status == 'Success') {
                    this.checkCode_4 = 1
                    this.point_4 = res.data.data.codes[this.code_4].points_earn
                  } else if (
                    res.data.data.codes[this.code_4].status == 'Used'
                  ) {
                    this.checkCode_4 = 2
                  } else {
                    this.checkCode_4 = 4
                  }
                }
                if (this.code_5 != '' && this.code_5 != null) {
                  if (res.data.data.codes[this.code_5].status == 'Success') {
                    this.checkCode_5 = 1
                    this.point_5 = res.data.data.codes[this.code_5].points_earn
                  } else if (
                    res.data.data.codes[this.code_5].status == 'Used'
                  ) {
                    this.checkCode_5 = 2
                  } else {
                    this.checkCode_5 = 4
                  }
                }

                var point = 0
                if (this.code_1 != '' && this.code_1 != null) {
                  if (res.data.data.codes[this.code_1].status == 'Success') {
                    point += res.data.data.codes[this.code_1].points_earn
                  }
                }
                if (this.code_2 != '' && this.code_2 != null) {
                  if (res.data.data.codes[this.code_2].status == 'Success') {
                    point += res.data.data.codes[this.code_2].points_earn
                  }
                }
                if (this.code_3 != '' && this.code_3 != null) {
                  if (res.data.data.codes[this.code_3].status == 'Success') {
                    point += res.data.data.codes[this.code_3].points_earn
                  }
                }
                if (this.code_4 != '' && this.code_4 != null) {
                  if (res.data.data.codes[this.code_4].status == 'Success') {
                    point += res.data.data.codes[this.code_4].points_earn
                  }
                }
                if (this.code_5 != '' && this.code_5 != null) {
                  if (res.data.data.codes[this.code_5].status == 'Success') {
                    point += res.data.data.codes[this.code_5].points_earn
                  }
                }
                let newCodesTemp = Object.values(res.data.data.codes)
                if (newCodesTemp.some(item => item.status == 'Success')) {
                  this.result_alert.show = true
                  this.result_alert.type = 'success'
                  this.result_alert.title = this.lbl.earnpoint.earnpoint_success
                  this.result_alert.desc =
                    point + ' ' + this.lbl.earnpoint.points
                  this.$forceUpdate()
                  clearTimeout(this.modaltimeOut)
                  this.modaltimeOut = setTimeout(() => {
                    this.afterCloseModal()
                  }, 5000)
                } else if (
                  newCodesTemp.every(item => item.status !== 'Success')
                ) {
                  this.result_alert.show = true
                  this.result_alert.type = 'error'
                  this.result_alert.title = this.lbl.earnpoint.earnpoint_error
                  this.result_alert.desc = this.lbl.earnpoint.earnpoint_error_desc
                  this.$forceUpdate()
                  clearTimeout(this.modaltimeOut)
                  this.modaltimeOut = setTimeout(() => {
                    this.afterCloseModal()
                  }, 5000)
                }

                if (point > 0) {
                  this.showNotification = true
                  this.dataNotification = {
                    condition: 'correct',
                    title: this.lbl.earnpoint.you_success,
                    detail: point,
                  }
                } else {
                  if (this.code_1 != '' && this.code_1 != null) {
                    if (res.data.data.codes[this.code_1].status == 'Used') {
                      this.showNotification = true
                      this.dataNotification = {
                        condition: 'usecode',
                        title: this.lbl.earnpoint.used_code,
                      }
                    } else {
                      this.showNotification = true
                      this.dataNotification = {
                        condition: 'incorrect',
                        title: this.lbl.earnpoint.incorrect_code,
                      }
                    }
                  } else if (this.code_2 != '' && this.code_2 != null) {
                    if (res.data.data.codes[this.code_2].status == 'Used') {
                      this.showNotification = true
                      this.dataNotification = {
                        condition: 'usecode',
                        title: this.lbl.earnpoint.used_code,
                      }
                    } else {
                      this.showNotification = true
                      this.dataNotification = {
                        condition: 'incorrect',
                        title: this.lbl.earnpoint.incorrect_code,
                      }
                    }
                  } else if (this.code_3 != '' && this.code_3 != null) {
                    if (res.data.data.codes[this.code_3].status == 'Used') {
                      this.showNotification = true
                      this.dataNotification = {
                        condition: 'usecode',
                        title: this.lbl.earnpoint.used_code,
                      }
                    } else {
                      this.showNotification = true
                      this.dataNotification = {
                        condition: 'incorrect',
                        title: this.lbl.earnpoint.incorrect_code,
                      }
                    }
                  } else if (this.code_4 != '' && this.code_4 != null) {
                    if (res.data.data.codes[this.code_4].status == 'Used') {
                      this.showNotification = true
                      this.dataNotification = {
                        condition: 'usecode',
                        title: this.lbl.earnpoint.used_code,
                      }
                    } else {
                      this.showNotification = true
                      this.dataNotification = {
                        condition: 'incorrect',
                        title: this.lbl.earnpoint.incorrect_code,
                      }
                    }
                  } else if (this.code_5 != '' && this.code_5 != null) {
                    if (res.data.data.codes[this.code_5].status == 'Used') {
                      this.showNotification = true
                      this.dataNotification = {
                        condition: 'usecode',
                        title: this.lbl.earnpoint.used_code,
                      }
                    } else {
                      this.showNotification = true
                      this.dataNotification = {
                        condition: 'incorrect',
                        title: this.lbl.earnpoint.incorrect_code,
                      }
                    }
                  }
                }
              } else {
                this.code_1 != ''
                  ? (this.checkCode_1 = 4)
                  : (this.checkCode_1 = 0)
                this.code_2 != ''
                  ? (this.checkCode_2 = 4)
                  : (this.checkCode_2 = 0)
                this.code_3 != ''
                  ? (this.checkCode_3 = 4)
                  : (this.checkCode_3 = 0)
                this.code_4 != ''
                  ? (this.checkCode_4 = 4)
                  : (this.checkCode_4 = 0)
                this.code_5 != ''
                  ? (this.checkCode_5 = 4)
                  : (this.checkCode_5 = 0)
              }
            } else {
              this.code_1 != ''
                ? (this.checkCode_1 = 5)
                : (this.checkCode_1 = 0)
              this.code_2 != ''
                ? (this.checkCode_2 = 5)
                : (this.checkCode_2 = 0)
              this.code_3 != ''
                ? (this.checkCode_3 = 5)
                : (this.checkCode_3 = 0)
              this.code_4 != ''
                ? (this.checkCode_4 = 5)
                : (this.checkCode_4 = 0)
              this.code_5 != ''
                ? (this.checkCode_5 = 5)
                : (this.checkCode_5 = 0)

              if (res.data.success == false && res.data.code == 403) {
                this.showError = true
                this.dataError = {
                  title: this.lbl.error.errortitle,
                  detail: this.lbl.earnpoint.you_can_notenter_code_because,
                }
                this.$forceUpdate()
              } else if (res.data.success == false && res.data.code !== 403) {
                this.result_alert.show = true
                this.result_alert.type = 'error'
                this.result_alert.title = this.lbl.earnpoint.earnpoint_error
                this.result_alert.desc = this.lbl.earnpoint.earnpoint_error_desc
                this.$forceUpdate()
                clearTimeout(this.modaltimeOut)
                this.modaltimeOut = setTimeout(() => {
                  this.afterCloseModal()
                }, 5000)
              }
            }
            this.handleLoading(false)
            resolve(res.data)
          })
          .catch(error => {
            this.handleLoading(false)
            // console.log('postCouponProcess error', error.response.data)
            this.showError = true
            this.dataError = {
              title: this.lbl.error.errortitle,
              detail: error.response ? error.response.data.error.message : '',
            }
            resolve(error)
          })
      })
    },

    //Error
    ChangeError(event) {
      this.showError = event
      this.dataError = {}
    },
    ChangeNotification(event) {
      this.showNotification = event
      this.dataNotification = {}
      this.getProfile()
    },
  },
}
</script>

<style lang="scss">
@import '@/style/_mixin.scss';

.wrapper-earnPoint {
  .enter-code-wrapper {
    .ant-input {
      border-top-left-radius: 20px !important;
      border-bottom-left-radius: 20px !important;
      border-top-right-radius: 20px !important;
      border-bottom-right-radius: 20px !important;
    }
  }

  .img-code {
    margin-top: 0px;
  }

  .code-success {
    font-size: 14px;
    font-weight: 500;
    font-style: italic;
    color: #4caf50;
    padding-right: 5px;
  }

  .code-error {
    font-size: 14px;
    font-weight: 500;
    font-style: italic;
    color: #ff5252;
    padding-right: 5px;
  }

  .camera-wrapper {
    display: flex;
    align-items: center;

    .line-before-camera {
      width: 1px;
      height: 25px;
      margin: 0;
      background-color: #e3e3e3;
    }

    .img-code-scan {
      margin: auto 8px;
    }

    .code-scan-text {
      font-size: 16px;
    }
  }

  .events-none {
    pointer-events: none;
  }

  .ant-input-group {
    width: 100%;
    height: 45px;
    border-radius: 20px !important;
    box-shadow: 0 4px 8px 0 rgb(0 0 0 / 16%);
    margin: 8px 0;
  }

  .ant-input {
    float: left;
    text-align: inherit;
    width: 100%;
    height: 50px;
    border: solid 1px #ededed;
    background-color: #fff;
    padding: 10px 0px 10px 15px;
    font-size: 15px;
    color: #616161;
    font-weight: 500;
    border-radius: 30px !important;
    border: 1px solid #ededed;
    box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.16);
  }

  .ant-btn-lg {
    text-align: inherit;
    height: 50px;
    border: solid 1px #ededed;
    background-color: #fff;
    border-radius: 30px !important;
    border: 1px solid #ededed;
    box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.16);
  }

  .ant-input-group-addon {
    background-color: transparent;
  }

  .input_earncode {
    width: 100%;
    height: 45px;
    border-radius: 20px;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.16);
    border: solid 1px #ededed;
    background-color: #fff;
    margin: 8px 0;
    padding: 10px 15px;
    font-size: 15px;
    color: #616161;
    font-weight: 500;
  }

  .title-code {
    font-size: 15px;
    font-weight: 500;
    line-height: normal;
    color: #9e9e9e;
    padding-top: 4px;
    margin: 8px 0;
  }

  .img-earnpoint {
    padding-top: 12px;
    width: 100%;
    max-height: 125px;
  }

  .lbl-point {
    flex-grow: 0;
    font-size: 20px;
    font-weight: 600;
    line-height: 1.5;
    text-align: left;
    color: #232323;
    padding-left: 16px;
  }

  .box-profile {
    display: flex;
    justify-content: space-between;
    margin: 12px auto 16px;

    .profile {
      display: flex;
      text-align-last: right;
      gap: 16px;
      font-size: 20px;
      font-weight: 400;
      color: #232323;
      align-items: center;

      .lbl-point-w {
        font-size: 24px;
        font-weight: 700;
      }
    }
  }

  .wrapper-detail {
    padding-left: 15px;
    padding-right: 15px;

    .earnpoint-explanation {
      font-size: 15px;
      margin-top: 16px;
    }
  }

  .btn-submit {
    width: 100%;
    height: 40px;
    font-size: 20px;
    font-weight: 600;
    line-height: 2;
    letter-spacing: normal;
    text-align: center;
    justify-content: center;
    vertical-align: middle;
    color: #fff;
    cursor: pointer;
  }

  .profile_image {
    width: 65px;
    height: 65px;
    margin: 0;
    border-radius: 50px;
  }

  .enter-code-wrapper {
    display: flex;
    flex-direction: column;
    gap: 8px;
    .input2,
    .input3,
    .input4,
    .input5 {
      input {
        border: 1px solid var(--dust-red-5, #ff4d4f);
      }
    }
  }
}

.wrapper-earnPoint {
  @media only screen and (min-device-width: 600px) and (min-device-height: 600px) {
    .wrapper__earnpoint__page {
      border-top-left-radius: 40px;
      border-top-right-radius: 40px;
      margin-top: -50px;
      background-color: white;

      .title {
        padding: 10px;

        .text-title {
          font-size: 18px;
          font-weight: 500;
          margin-left: 10px;
          color: #666;
          line-height: 1.17;
        }
      }

      padding: 0px 5px;

      .wrapper_hearder {
        padding: 20px 20px 0 20px;
      }

      .wrapper_content {
        padding: 0 20px 0 20px;
      }
    }

    height: 100%;
    width: 100%;

    .wrapper__earnpoint__page {
      width: 90%;
      top: 20%;
      margin-top: 20px;
      margin-bottom: 50px;
      border-radius: 10px;

      .wrapper_content {
        margin-top: 10px;
      }
    }

    .image__hearder {
      height: 100%;
      overflow: auto;
      background-repeat: round;
      background-size: cover;
    }

    .box_content {
      min-height: 100%;
      align-items: center;
      -webkit-box-align: center;
      justify-content: center;
      vertical-align: middle;
      display: flex;
      width: 100%;
    }

    .footer {
      margin: 85px 0 10px 0;
      padding-bottom: 10px;

      .container {
        position: relative;
        bottom: 0px;
      }
    }
  }

  .footer.earnpoint .container {
    z-index: 2 !important;
  }

  @media only screen and (min-device-width: 600px) and (min-device-height: 600px) and (orientation: landscape) {
    .wrapper__earnpoint__page {
      margin-top: 80px !important;
      margin-bottom: 100px !important;
    }
  }

  @media only screen and (min-device-width: 900px) {
    .wrapper__earnpoint__page {
      width: 75%;
    }
  }

  @media only screen and (min-device-width: 1200px) {
    .wrapper__earnpoint__page {
      width: 60%;
    }
  }

  //แนวนอน
  @media only screen and (orientation: landscape) {
    .bzb__logo {
      position: relative;
    }
  }

  //แนวนอน
  @media only screen and (min-device-width: 640px) and (max-device-width: 823px) and (orientation: landscape) {
    .box_content {
      min-height: 740px;
    }
  }
}

.ant-alert {
  width: 100%;

  .alert-content {
    display: flex;
    gap: 16px;
    color: #424242;

    img {
      width: 40px;
      height: 40px;
    }

    .title {
      font-size: 16px;
      font-weight: 500;
      line-height: 24px;
      margin-bottom: 4px;
    }

    .point {
      font-size: 24px;
      font-weight: 700;
    }

    .desc {
      font-size: 12px;
      font-weight: 400;
    }
  }
}

.ant-alert-with-description {
  position: absolute;
  z-index: 9999;
}
</style>
